/**
 * @author Yara
 * @remarks Essa função foi extraída do validador de CNPJ
 * @link https://gist.github.com/alexbruno/6623b5afa847f891de9cb6f704d86d02
 * @param value String do CNPJ que se deseja validar
 * @returns true se for válido, false se for inválido
 */
export function isCnpjValid(value: Array<String> | number | string | null): boolean {
  if (!value) return false
  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false
  if (isString) {
    const digitsOnly = /^\d{14}$/.test(value)
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)
    if (digitsOnly || validFormat) true
    else return false
  }
  const match = value.toString().match(/\d/g)
  const numbers = Array.isArray(match) ? match.map(Number) : []

  if (numbers.length !== 14) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  // Cálculo validador
  const calc = (validator: number) => {
    const slice = numbers.slice(0, validator)
    let factor = validator - 7
    let sum = 0

    for (let counter = validator; counter >= 1; counter--) {
      const n = slice[validator - counter]
      sum += n * factor--
      if (factor < 2) factor = 9
    }
    const result = 11 - (sum % 11)

    return result > 9 ? 0 : result
  }
  const digits = numbers.slice(12)

  const firstDigitValidator = calc(12)
  if (firstDigitValidator !== digits[0]) return false

  const secondDigitValidator = calc(13)
  return secondDigitValidator === digits[1]
}

export function maskCnpj(cnpj: string) {
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5')
}
